const KEY = "reelvault_watch_later";

export const getSaved = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const toggleSaved = (id) => {
  const cur = getSaved();
  const next = cur.includes(id) ? cur.filter((x) => x !== id) : [id, ...cur];
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event("watchlater-change"));
  return next;
};

export const clearSaved = () => {
  localStorage.setItem(KEY, JSON.stringify([]));
  window.dispatchEvent(new Event("watchlater-change"));
  return [];
};

export const setSavedLocal = (ids) => {
  localStorage.setItem(KEY, JSON.stringify(ids || []));
  window.dispatchEvent(new Event("watchlater-change"));
};
